// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"242":"740fc9b3","369":"a1b9de12","401":"92e30a12","543":"588b79f6","782":"3bb77b56","963":"a1b9de12","984":"9859d9af"}[chunkId] + ".chunk.css";
};